import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppUrlService } from 'core/services/auth/app.url.service';
import { AuthorizationService } from 'core/services/auth/authorization.service';
import { map } from 'rxjs/operators';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SuperAdminGuard implements CanActivate {
  private authorizationService = inject(AuthorizationService);
  private router = inject(Router);
  private appUrlService = inject(AppUrlService);

  public canActivate(): Observable<boolean> {
    return this.authorizationService.loggedInUser$.pipe(
      map((user) => user.isSuperAdmin),
      tap((isSuperAdmin) => {
        if (!isSuperAdmin) {
          this.router.navigate([this.appUrlService.getHomeUrl()]);
        }
      })
    );
  }
}
